import React, { useState } from "react";
import { useDispatch, useSelector } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";
import styles from "./style.module.css";
import { Accordion, Button, ButtonGroup } from "aible";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import SeeWhatWasSentUsage from "components/ChatGPT/SeeWhatWasSentUsage";
import { ChatMessageContent } from "components/ChatGPT/ChatGPT";
import SqlBarChart from "components/ChatGPT/SqlBarChart";
import NextChartContainer from "components/Next/Charts/NextChart";
import * as nextReducer from "containers/Next/NextReducer";
import { isEnabled } from "utils/featureFlags";
import RatingInput from "./RatingInput";
import MarkdownPanel from "./MarkdownPanel";
const SeeWhatWasSent = (props) => {
    const { contentGenerationId, accountId, isFetchingDetails, updateFetchingId } = props;
    const dispatch = useDispatch();
    const chatMessageDetail = useSelector((state) => chatDetailsReducer.getChatMessageDetails(state, contentGenerationId));
    const isLoadingId = isFetchingDetails[contentGenerationId] === true;
    const detailIsLoaded = useSelector((state) => chatDetailsReducer.getDetailIsLoaded(state, contentGenerationId));
    const chatDetailContent = chatMessageDetail?.results;
    const fetchChatMessageDetails = () => dispatch(chatDetailsReducer.fetchChatMessageDetails(contentGenerationId, accountId));
    const [isOpen, updateIsOpen] = useState(false);
    const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
    const linkColorDarkColor = "#1F181C";
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const showRequestJSON = useSelector((state) => chatGPTReducer.getShowRequestJSON(state));
    if (!showRequestJSON) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("a", { onClick: (e) => {
                    e.preventDefault();
                    if (!isOpen && !isLoadingId && !detailIsLoaded) {
                        updateFetchingId(contentGenerationId, true);
                        fetchChatMessageDetails().then(() => {
                            updateFetchingId(contentGenerationId, false);
                        });
                    }
                    updateIsOpen(!isOpen);
                }, className: styles.seeWhatWasSentLink, style: {
                    color: linkColorDarkMode
                        ? linkColorDarkColor
                        : chatApp?.wizard?.linkColor !== undefined
                            ? chatApp?.wizard?.linkColor
                            : undefined
                } }, isOpen ? "Hide Details" : (props?.customLabel !== undefined ? props?.customLabel : "") + "See what was sent")),
        isOpen && (React.createElement("div", { className: styles.seeWhatWasSentContentContainer },
            isLoadingId && (React.createElement("div", { className: styles.seeWhatWasSentLoadingWrapper },
                "Loading details...",
                React.createElement(LoadingIndicator, null))),
            !isLoadingId && chatDetailContent && (React.createElement("div", null,
                React.createElement("div", { className: styles.seeWhatWasSentTitle }, `This Question Sent ${chatDetailContent?.length} ${chatDetailContent?.length === 1 ? "Query" : "Queries"}`),
                !(chatDetailContent?.length > 0) && (React.createElement("div", { className: styles.seeWhatWasSentMissingQueryLabel }, "The query information may be missing.")),
                chatDetailContent.map((contentItem, index) => {
                    return (React.createElement(ChatDetailItem, { executionId: contentGenerationId, result: contentItem, key: "detail_item__" + contentItem.id, index: index }));
                }),
                React.createElement("div", { className: styles.seeWhatWasSentExecutionId }, `Execution ID: ${contentGenerationId}`)))))));
};
export default SeeWhatWasSent;
const ChatDetailItem = ({ executionId, result, index }) => {
    const dispatch = useDispatch();
    const [outputRenderMode, updateOutputRenderMode] = useState("markdown");
    const content = result.data;
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const inputMessages = content?.input?.messages ?? [];
    const outputContent = content?.output?.content;
    const renderedOutputContent = outputRenderMode === "raw" ? (outputContent) : (React.createElement(MarkdownPanel, { overrides: chatGPTReducer.CHAT_MARKDOWN_OVERRIDES }, outputContent));
    const generationConfig = content?.input?.generation_config;
    const generationData = inputMessages
        .map((m) => m?.reference_data)
        .filter((rData) => rData?.length)
        .flatMap((rData) => rData);
    // We only support datasetQuery charts right now but this can also have "TARGET_ANALYSIS" charts
    const hasCharts = Boolean(generationData.find((gData) => {
        return gData?.type === "DATASET_QUERY" || gData?.type === "TARGET_ANALYSIS";
    }));
    const smallerButtonStyle = { padding: "5px" };
    return (React.createElement("div", { className: styles.chatDetailItemWrapper },
        React.createElement(Accordion, { header: React.createElement("div", { className: styles.seeWhatWasSentQueryLabel }, `Query ${index + 1} Message and Settings`), defaultShow: true },
            inputMessages?.length > 0 && (React.createElement("div", { className: styles.chatDetailItemSection },
                React.createElement("div", { className: styles.seeWhatWasSentQueryItem },
                    inputMessages?.map((inputItem, index) => (React.createElement(React.Fragment, { key: "input_item__" + index },
                        inputItem.role == "system" && (React.createElement("div", { className: styles.seeWhatWasSentQueryLabel }, "System Instructions:")),
                        inputItem.role == "user" && React.createElement("div", { className: styles.seeWhatWasSentQueryLabel }, "Prompt:"),
                        React.createElement("div", { className: styles.seeWhatWasSentInputsContainer },
                            React.createElement(InputMessage, { message: inputItem }))))),
                    hasCharts ? (React.createElement("div", { className: styles.seeWhatWasSentInputsContainer }, generationData?.map((gData, index) => {
                        if (gData?.type === "DATASET_QUERY") {
                            const chartData = gData?.results;
                            if (!chartData?.length) {
                                return null;
                            }
                            return (React.createElement("div", { key: "chart" + index, className: styles.sqlChart, style: { marginBottom: "20px", width: "100%" } },
                                React.createElement(SqlBarChart, { data: chartData, isEditChart: false })));
                        }
                        else if (gData?.type === "TARGET_ANALYSIS") {
                            const chartData = gData?.charts;
                            if (!chartData?.length) {
                                return null;
                            }
                            return chartData.map((fChart) => {
                                return (React.createElement("div", { key: "chart" + index, className: styles.analyticsChart, style: { marginBottom: "20px", width: "100%" } },
                                    React.createElement(NextChartContainer, { id: fChart.report_id ?? nextId, chart: fChart, datasetId: fChart.dataset_id ?? datasetId, showLeakage: true, showTooltip: true, isShowMore: true, isChatGPT: true })));
                            });
                        }
                        return null;
                    }))) : null,
                    generationConfig && (React.createElement("div", { className: styles.generationConfigWrapper },
                        React.createElement("div", { className: styles.generationConfigLabel }, "LLM Settings"),
                        React.createElement("div", null, `Model ID: ${generationConfig?.model}`),
                        generationConfig?.max_tokens !== undefined && (React.createElement("div", null, `Max Tokens: ${generationConfig?.max_tokens}`)),
                        React.createElement("div", null, `Frequency Penalty: ${generationConfig?.frequency_penalty}`),
                        React.createElement("div", null, `Presence Penalty: ${generationConfig?.presence_penalty}`),
                        React.createElement("div", null, `Temperature: ${generationConfig?.temperature}`),
                        React.createElement("div", null, `Top P: ${generationConfig?.top_p}`),
                        React.createElement("div", null, `Top K: ${generationConfig?.top_k}`)))),
                !isEnabled("chat-aible-hide-token-costs") && content?.input?.usage && (React.createElement("div", { className: styles.seeWhatWasSentQueryItem },
                    React.createElement("div", { className: styles.seeWhatWasSentUsageLabel }, "Input Usage"),
                    React.createElement("div", null,
                        React.createElement(SeeWhatWasSentUsage, { usage: content.input.usage })))))),
            outputContent && (React.createElement("div", { className: styles.chatDetailItemSection },
                React.createElement("div", { className: styles.seeWhatWasSentQueryItem },
                    React.createElement("div", { className: styles.seeWhatWasSentQueryLabel }, "This was the response:"),
                    React.createElement("div", { className: styles.seeWhatWasSentOutputContainer }, renderedOutputContent)),
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { style: smallerButtonStyle, onClick: () => {
                            updateOutputRenderMode("markdown");
                        }, active: outputRenderMode === "markdown", greyscaleDefaultState: true }, "Markdown"),
                    React.createElement(Button, { style: smallerButtonStyle, onClick: () => {
                            updateOutputRenderMode("raw");
                        }, active: outputRenderMode === "raw", greyscaleDefaultState: true }, "Plain Text")),
                React.createElement("div", { className: styles.seeWhatWasSentQueryItem },
                    React.createElement(RatingInput, { type: "CONTENT_GENERATION_RESULT", value: result, afterUpdate: () => dispatch(chatDetailsReducer.fetchChatMessageDetails(executionId)).then(() => {
                            return;
                        }) }),
                    !isEnabled("chat-aible-hide-token-costs") && content?.output?.usage && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.seeWhatWasSentUsageLabel }, "Output Usage"),
                        React.createElement("div", null,
                            React.createElement(SeeWhatWasSentUsage, { usage: content.output.usage }))))))),
            !isEnabled("chat-aible-hide-token-costs") && content?.usage && (React.createElement("div", { className: styles.seeWhatWasSentQueryItem },
                React.createElement("div", { className: styles.seeWhatWasSentUsageLabel }, "Total Usage for this Query"),
                React.createElement(SeeWhatWasSentUsage, { usage: content.usage }))))));
};
const InputMessage = ({ message }) => {
    return React.createElement(ChatMessageContent, { content: message?.content });
};
